class ticketedPointCtrl {
    constructor($rootScope, $scope, logger) {
        // 用户信息
        const userInfo = JSON.parse(localStorage.user_info)
        if (!userInfo.sale) {
            logger.logTips('当前机构下没有配置纳税人识别号，请补充', 'warn')
        } else {
            const { saleId } = userInfo.sale
            const { saleCreditCode } = userInfo.sale
            const { taxDiskType } = userInfo.sale
            const { saleName } = userInfo.sale
            // 存储页面信息
            $scope.pageState = {
                idToken: $rootScope.idToken,
                userInfo,
                taxDiskType: Number(taxDiskType),
                tabTaxDiskType: 0,
                saleName,
                saleCreditCode,
                saleId,
                diskType: 2,
            }
        }
    }
}
ticketedPointCtrl.$inject = ['$rootScope', '$scope', 'logger']
export default ticketedPointCtrl



// WEBPACK FOOTER //
// ./src/app/system/basedata/ticketedPoint/ticketedPointCtrl.js